import React, { useState } from 'react';
import './Catalogues.css';

function Catalogues() {
  const [selectedCatalog, setSelectedCatalog] = useState('2021-22');

  const catalogues = {
    '2021-22': {
      title: "2021/22 CATALOGUE",
      subtitle: "Celebrating & Uniting All Shapes",
      description: "Welcome to our first ever product catalogue for both the shapes united and recovawear. We are super excited to feature both brands showcasing our Adaptive & Sensory Collections.",
      image: "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Adaptive Collection Highlights",
        "Sensory Friendly Designs",
        "How to Wear Guides",
        "Complete Sizing Information",
        "NDIS & Rebate Information",
        "Wholesale Partnership Details"
      ],
      downloadLink: "/catalogues/2021-22-catalogue.pdf"
    },
    '2023-24': {
      title: "2023/24 COLLECTION",
      subtitle: "Innovation in Adaptive Fashion",
      description: "Our latest collection featuring expanded ranges, new sustainable fabrics, and enhanced adaptive features. Discover our newest designs for men, women, and children.",
      image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      features: [
        "New Sustainable Fabrics",
        "Expanded Size Ranges",
        "Seasonal Collections",
        "Caregiver Guides",
        "HCP Integration Details",
        "Customer Stories"
      ],
      downloadLink: "/catalogues/2023-24-collection.pdf"
    },
    'lookbook': {
      title: "STYLE LOOKBOOK",
      subtitle: "Adaptive Fashion in Action",
      description: "See how real people style and wear The Shapes United collections in everyday life. Featuring lifestyle photography and styling tips.",
      image: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Real Customer Styling",
        "Seasonal Outfit Ideas",
        "Accessory Pairing Tips",
        "Day-to-Night Transformations",
        "Caregiver Styling Guides",
        "Photography by Real Users"
      ],
      downloadLink: "/catalogues/style-lookbook.pdf"
    },
    'wholesale': {
      title: "WHOLESALE CATALOGUE",
      subtitle: "Partner with The Shapes United",
      description: "Complete wholesale information for healthcare providers, retail partners, and institutions. Learn about our partnership programs and bulk ordering.",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
      features: [
        "Bulk Pricing Tiers",
        "Healthcare Provider Discounts",
        "Custom Branding Options",
        "Institutional Partnerships",
        "Minimum Order Information",
        "Shipping & Logistics"
      ],
      downloadLink: "/catalogues/wholesale-catalogue.pdf"
    }
  };

  return (
    <div className="catalogues-page">
      {/* Hero Section */}
      <section className="catalog-hero">
        <div className="hero-overlay">
          <div className="container">
            <div className="hero-content">
              <h1>CATALOGUES & PUBLICATIONS</h1>
              <p className="hero-subtitle">Discover Our Collections & Resources</p>
              <p className="hero-text">
                Explore our product catalogues, style guides, and educational publications designed to help you make the most of adaptive fashion.
              </p>
              <div className="hero-buttons">
                <a href="#catalogues" className="hero-btn primary">View Catalogues</a>
                <a href="#publications" className="hero-btn secondary">Browse Publications</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Catalogue Section */}
      <section id="catalogues" className="main-catalogue-section">
        <div className="container">
          <div className="section-header">
            <h2>THE SHAPES UNITED - 2021/22 CATALOGUE</h2>
            <p className="catalogue-tagline">celebrating & uniting all shapes</p>
            <div className="catalogue-intro">
              <p>
                Welcome to our first ever product catalogue for both the shapes united and recovawear.
                We are super excited to feature both brands showcasing our Adaptive & Sensory Collections.
              </p>
              <p>
                You will also find out more about 'how to wear' clothing from our Adaptive Collections, Sizing Guides, Rebates, NDIS and how to become a Wholesaler for the shapes united or recovawear brands.
              </p>
            </div>
          </div>

          {/* Catalogue Preview */}
          <div className="catalogue-preview">
            <div className="preview-image">
              <img 
                src={catalogues[selectedCatalog].image} 
                alt={catalogues[selectedCatalog].title}
                className="catalogue-image"
              />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>{catalogues[selectedCatalog].title}</h3>
                  <p>{catalogues[selectedCatalog].subtitle}</p>
                  <a 
                    href={catalogues[selectedCatalog].downloadLink} 
                    className="download-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download PDF
                  </a>
                </div>
              </div>
            </div>
            
            <div className="preview-info">
              <div className="catalogue-selector">
                <h3>Browse Our Catalogues</h3>
                <div className="selector-buttons">
                  {Object.keys(catalogues).map(key => (
                    <button
                      key={key}
                      className={`selector-btn ${selectedCatalog === key ? 'active' : ''}`}
                      onClick={() => setSelectedCatalog(key)}
                    >
                      {catalogues[key].title.split(' ')[0]}
                    </button>
                  ))}
                </div>
              </div>
              
              <div className="catalogue-details">
                <h4>{catalogues[selectedCatalog].subtitle}</h4>
                <p>{catalogues[selectedCatalog].description}</p>
                
                <div className="features-list">
                  <h5>This Catalogue Includes:</h5>
                  <ul>
                    {catalogues[selectedCatalog].features.map((feature, index) => (
                      <li key={index}>
                        <span className="feature-icon">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="catalogue-actions">
                  <a 
                    href={catalogues[selectedCatalog].downloadLink}
                    className="action-btn primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="btn-icon">📥</span>
                    Download Full Catalogue
                  </a>
                  <button className="action-btn secondary">
                    <span className="btn-icon">🖨️</span>
                    Request Printed Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="container">
          <h2>What You'll Find in Our Catalogues</h2>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">👕</div>
              <h3>Adaptive Collections</h3>
              <p>Detailed showcases of our innovative adaptive clothing with magnetic closures, easy-access designs, and comfortable fabrics.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🌟</div>
              <h3>Sensory Collections</h3>
              <p>Explore our sensory-friendly clothing line featuring tagless designs, seamless construction, and soft, calming fabrics.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📏</div>
              <h3>Sizing Guides</h3>
              <p>Comprehensive sizing charts and fit guides to ensure perfect comfort and style for every body shape.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🎬</div>
              <h3>How to Wear</h3>
              <p>Step-by-step visual guides and tips for wearing and caring for adaptive clothing items.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Rebates & Funding</h3>
              <p>Information on NDIS, HCP, and other funding options available for adaptive clothing purchases.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3>Wholesale Partnerships</h3>
              <p>Details on becoming a wholesale partner for healthcare providers, institutions, and retail stores.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Digital Flipbook Section */}
      <section className="flipbook-section">
        <div className="container">
          <div className="flipbook-content">
            <div className="flipbook-text">
              <h2>Interactive Digital Flipbook</h2>
              <p>Experience our catalogues in an interactive digital format. Flip through pages, zoom in on details, and explore products in a truly engaging way.</p>
              
              <div className="flipbook-features">
                <div className="flip-feature">
                  <div className="flip-icon">📱</div>
                  <div>
                    <h4>Mobile Friendly</h4>
                    <p>Optimized for all devices</p>
                  </div>
                </div>
                
                <div className="flip-feature">
                  <div className="flip-icon">🔍</div>
                  <div>
                    <h4>Zoom & Pan</h4>
                    <p>Examine details closely</p>
                  </div>
                </div>
                
                <div className="flip-feature">
                  <div className="flip-icon">🔗</div>
                  <div>
                    <h4>Interactive Links</h4>
                    <p>Click to learn more</p>
                  </div>
                </div>
              </div>
              
              <a href="/digital-flipbook" className="flipbook-launch-btn">
                Launch Digital Flipbook
              </a>
            </div>
            
            <div className="flipbook-preview">
              <div className="flipbook-mockup">
                <div className="mockup-screen">
                  <img 
                    src="https://images.unsplash.com/photo-1544716278-e513176f20b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80" 
                    alt="Digital Flipbook Preview"
                  />
                  <div className="mockup-controls">
                    <div className="control prev">‹</div>
                    <div className="control next">›</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Request Section */}
      <section className="request-section">
        <div className="container">
          <div className="request-content">
            <div className="request-text">
              <h2>Need Custom Publications?</h2>
              <p>We can create customized catalogues and educational materials for healthcare institutions, universities, and partner organizations.</p>
              
              <div className="request-types">
                <div className="request-type">
                  <h4>Bulk Printed Copies</h4>
                  <p>Order printed catalogues for your organization or events.</p>
                </div>
                
                <div className="request-type">
                  <h4>Custom Branding</h4>
                  <p>Add your logo and messaging to our publications.</p>
                </div>
                
                <div className="request-type">
                  <h4>Educational Kits</h4>
                  <p>Complete resource kits for training and education.</p>
                </div>
              </div>
            </div>
            
            <div className="request-form">
              <h3>Request Custom Materials</h3>
              <form className="custom-request-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="organization">Organization</label>
                    <input type="text" id="organization" placeholder="Your organization name" />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="purpose">Purpose</label>
                    <select id="purpose">
                      <option value="">Select purpose</option>
                      <option value="education">Educational Use</option>
                      <option value="healthcare">Healthcare Provider</option>
                      <option value="retail">Retail Partner</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="materials">Materials Needed</label>
                  <textarea 
                    id="materials" 
                    placeholder="Describe the custom materials you need..."
                    rows="3"
                  ></textarea>
                </div>
                
                <div className="form-group">
                  <label htmlFor="quantity">Quantity Needed</label>
                  <input type="number" id="quantity" placeholder="Approximate quantity" min="1" />
                </div>
                
                <button type="submit" className="submit-request-btn">
                  Submit Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h2>Stay Updated</h2>
              <p>Subscribe to receive new catalogues, publications, and updates about The Shapes United collections.</p>
            </div>
            
            <form className="newsletter-form">
              <div className="form-inputs">
                <input type="email" placeholder="Your email address" />
                <select>
                  <option value="">Select interests</option>
                  <option value="catalogues">New Catalogues</option>
                  <option value="publications">Educational Publications</option>
                  <option value="updates">Product Updates</option>
                  <option value="all">All Updates</option>
                </select>
              </div>
              <button type="submit" className="subscribe-btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Catalogues;
